// Recent Adventures — a small recency list (NOT a progress store). Additive key;
// existing progress systems are untouched. Powers CONTINUE / RECENT ADVENTURES.
import { catalogFor } from "@/lib/catalog";
import { getLessonPercent } from "@/lib/lessonStageProgress";
import { isEpisodeComplete } from "@/lib/storyProgress";

export const RECENT_KEY = "mwq_recent_adventures_v1";
const MAX = 12;
const SKIP = ["/", "/everything", "/play", "/games", "/passport", "/my-quest", "/portfolio", "/family", "/learn-pathways", "/learn-topics", "/stories", "/globe", "/continents", "/learn-countries", "/sitemap", "/search"];

function load() { try { return JSON.parse(localStorage.getItem(RECENT_KEY) || "[]") || []; } catch { return []; } }
function save(list) { try { localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, MAX))); window.dispatchEvent(new CustomEvent("mwq-recent-changed")); } catch { /* ignore */ } }

/** Call on route change. Only concrete activities are remembered (not hubs). */
export function rememberVisit(pathname, search = "") {
  const p = (pathname || "/").replace(/\/+$/, "") || "/";
  if (SKIP.includes(p) || p.startsWith("/grown-ups") || p.startsWith("/parents") || p.startsWith("/teacher") || p.startsWith("/admin")) return;
  const c = catalogFor(p);
  if (!c) return;
  const full = p + (search && p === "/coloring" ? search : "");
  const list = load().filter((x) => x.to !== full);
  list.unshift({ to: full, title: c.name, emoji: c.emoji, type: c.type, at: Date.now() });
  save(list);
}

export function recentAdventures(limit = 5) { return load().slice(0, limit); }

/**
 * The most recent activity worth continuing, based on learner STATE (not just the last URL):
 * lessons already completed are skipped, and only resumable kinds count (games/quizzes are "play again", not "continue").
 */
export function continueAdventure() {
  const RESUMABLE = new Set(["learn", "story", "academy", "quest", "assessment", "creative"]);
  return load().find((x) => {
    if (!RESUMABLE.has(x.type)) return false;
    const m = /^\/(lesson|practice)\/([^/?#]+)/.exec(x.to);
    if (m) return getLessonPercent(m[2]) < 100;
    const s = /^\/story\/([^/]+)\/([^/?#]+)/.exec(x.to);
    if (s) return !isEpisodeComplete(s[1], s[2]);
    return true;
  }) || null;
}

export function clearRecent() { save([]); }
